import React, { useState, useEffect } from 'react'
import LoginHeader from '../../components/header/LoginHeaderR'
import './MiniAgentReferralHistory.css';
import { useNavigate } from 'react-router-dom';
import { API_URL } from '../../../src/constant.js';

function MiniAgentReferralHistory() {
    const [currentPage, setCurrentPage] = useState(1);
    const [referrals, setReferrals] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const itemsPerPage = 6;
    const navigate = useNavigate();

    // Fetch referral data from API
    const fetchReferralHistory = async (page = 1) => {
        try {
            setLoading(true);
            const token = localStorage.getItem('auth_token');
            
            const response = await fetch(
                `${API_URL}/api/retail-business/business-agent-referral-history?page=${page}&per_page=${6}`, 
                {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                }
            );

            if (!response.ok) {
                throw new Error('Failed to fetch referral history');
            }

            const data = await response.json();
            setReferrals(data.referrals || []);
            setError('');
            
        } catch (err) {
            setError(err.message);
            console.error('Error fetching referral history:', err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchReferralHistory(currentPage);
    }, [currentPage]);

    const handlePageChange = (newPage) => {
        setCurrentPage(newPage);
    };

    // Calculate pagination details
    const totalPages = Math.ceil(referrals.length / itemsPerPage);
    const startIndex = (currentPage - 1) * itemsPerPage;
    const paginatedReferrals = referrals.slice(startIndex, startIndex + itemsPerPage);

    // Helper function to format location display
    const formatLocation = (country, region) => {
        if (country && region) {
            return `${country}, ${region}`;
        } else if (country) {
            return country;
        } else if (region) {
            return region;
        }
        return 'N/A';
    };

    // Loading icon component
    const LoadingIcon = () => (
        <div className="loading-container">
            <div className="loading-spinner"></div>
            <p style={{ marginTop: '10px', color: 'white' }}>Loading referral history...</p>
        </div>
    );

    if (loading) {
        return (
            <div className="pt-5" style={{ backgroundColor: "#001964" }}>
                <LoginHeader />
                <div className="wallet-container">
                    <div className="referral-table">
                        <h2>Referral History</h2>
                        <button className="close-btn" onClick={() => navigate("/customer/wallet")}>✕</button>
                        <LoadingIcon />
                    </div>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="pt-5" style={{ backgroundColor: "#001964" }}>
                <LoginHeader />
                <div className="wallet-container">
                    <div className="referral-table">
                        <h2>Referral History</h2>
                        <button className="close-btn" onClick={() => navigate("/customer/wallet")}>✕</button>
                        <div style={{ textAlign: 'center', padding: '50px', color: 'white' }}>
                            Error: {error}
                            <br />
                            <button 
                                onClick={() => fetchReferralHistory(currentPage)} 
                                style={{ 
                                    marginTop: '10px', 
                                    padding: '8px 16px', 
                                    backgroundColor: '#003087', 
                                    color: 'white', 
                                    border: 'none', 
                                    borderRadius: '4px',
                                    cursor: 'pointer'
                                }}
                            >
                                Retry
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="pt-5" style={{ backgroundColor: "#001964" }}>
            <LoginHeader />
            <div className="wallet-container">
                <div className="referral-table">
                    <h2>Referral History</h2>
                    <button className="close-btn" onClick={() => navigate("/customer/wallet")}>✕</button>
            
                    <table className="user-table">
                        <thead>
                            <tr>
                                <th>No</th>
                                <th>Name</th>
                                <th>Role</th>
                                <th>Location</th>
                                <th>Joined Date</th>
                            </tr>
                        </thead>
                        <tbody>
                            {paginatedReferrals.length > 0 ? (
                                paginatedReferrals.map((referral, index) => (
                                    <tr key={referral.customer_id || index}>
                                        <td>{startIndex + index + 1}</td>
                                        <td>{referral.name}</td>
                                        <td>Customer</td>
                                        <td>{formatLocation(referral.country, referral.region)}</td>
                                        <td>{referral.joined_date}</td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="5" style={{ textAlign: "center" }}>
                                        No referrals found
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>

                    {/* Pagination */}
                    <div className="pagination">
                        <button 
                            className="page-btn" 
                            onClick={() => handlePageChange(Math.max(currentPage - 1, 1))}
                            disabled={currentPage === 1}
                        >
                            &lt;
                        </button>
                        {Array.from({ length: totalPages }, (_, i) => (
                            <button
                                key={i}
                                className={`page-btn ${currentPage === i + 1 ? "active" : ""}`}
                                onClick={() => handlePageChange(i + 1)}
                            >
                                {i + 1}
                            </button>
                        ))}
                        <button 
                            className="page-btn" 
                            onClick={() => handlePageChange(Math.min(currentPage + 1, totalPages))}
                            disabled={currentPage === totalPages}
                        >
                            &gt;
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default MiniAgentReferralHistory;